import logoSquareUrl from '@assets/logo/M_WHITE_LOGO_SQUARE.svg';

import './styles.scss';

/**
 * AppMark — the app icon the way the share card draws its subject: an ink
 * squircle carrying the mark in surface color. Themed through the surface
 * scale, so it reads as the store icon on both light and dark.
 */
export default function AppMark({ size = 80 }) {
    return (
        <span className="app-mark" style={{ width: size, height: size }} aria-hidden="true">
            <span
                className="app-mark__glyph"
                style={{ WebkitMaskImage: `url(${logoSquareUrl})`, maskImage: `url(${logoSquareUrl})` }}
            />
        </span>
    );
}
